import { InputProps, SelectInput } from "react-admin"

const REGION_CODE_OPTIONS = [
  {
    id: "de_bayern",
    name: "de_bayern",
  },
  {
    id: "de_test1",
    name: "de_test1",
  },
  {
    id: "es_test1",
    name: "es_test1",
  },
  {
    id: "es_test2",
    name: "es_test2",
  },
]

export const LocationRegionInput: React.FC<InputProps> = (props) => (
  <SelectInput {...props} choices={REGION_CODE_OPTIONS} />
)
